<template>
  <div>
    <ContentLoader
      :height="72"
      :width="720"
      :speed="1"
      preserve-aspect-ratio="none"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="list-item"
      v-for="i in listSize"
      :key="i"
    >
      <rect x="0" y="0" rx="4" ry="4" width="720" height="72" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>

.list-item {
  height: 72px;
  margin-bottom: var(--space-medium);
  width: 100%;
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  props: {
    listSize: {
      type: Number,
      default: 5,
    },
  },
  components: {
    ContentLoader,
  },
};
</script>
